const ButtonCancel = ({
    children,
    buttonValue = children ? "" : "button",
    type = "submit",
    onClickFunction,
    className,
  }) => {
    return (
      <button
        type={type}
        value={buttonValue}
        onClick={onClickFunction}
        className={`hover:scale-90 transition duration-500 flex items-center bg-red-500 text-xs shadow-md font-semibold text-white justify-center gap-x-1 rounded-full px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70 ${className}`}
      >
        {buttonValue}
        {children}
      </button>
    );
  };
  
  export default ButtonCancel;
  